module.exports = __webpack_public_path__ + "img/mv3.a08a9138.png";